import AppToggle from "../ui/app-toggle";
import SidebarToggle from "../ui/sidebar-toggle";
import BottomMenuItems from "./bottom-menu-items";
import TopNav from "./top-nav";
import UserContext from "../../contexts/user-context";
import BusinessContext from "../../contexts/business-context";
import { useContext } from "react";
import DynamicIcon from "../ui/dynamic-icon";
import Link from "next/link";
import ComingSoonText from "../ui/coming-soon-text";

const MainMenuItems = ({ children }) => {
  const userCtx = useContext(UserContext);
  const businessCtx = useContext(BusinessContext);
  const business = businessCtx.activeBusiness;
  const user = userCtx.user;
  return (
    <div className="grid gap-[28px] content-start">
      <div className={`flex items-center justify-between ${business.is_pseudonymous ? '' : 'mx-[20.5px] lg:mx-0 lg:ml-[30px] lg:mr-[18px]'} `}>
        {/* {(user.is_pseudonymous === false && business.is_pseudonymous === false) && <AppToggle />} */}
        <Link href={ `/${business.uuid}/inbox`} className="lg:p-[10px] flex items-center gap-[4px]">
          <DynamicIcon name='mail' size={24} />
          <ComingSoonText>Beta</ComingSoonText>
        </Link>
        <SidebarToggle />
      </div>
      <div className="grid max-h-[calc(100dvh-315px)] overflow-y-auto overflow-x-hidden custom-scrollbar lg:px-[17.5px]">
        <div className="grid gap-4">
          {children}
        </div>
      </div>
    </div>
  );
}

export default MainMenuItems;
